import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { adminTenantSubscriptionsService } from "@/services/admin-tenant-subscriptions-service";
import type { AdminTenantSubscriptionOverviewFilters } from "@/types/tenant-subscription";

export const adminTenantSubscriptionKeys = {
  all: ["adminTenantSubscriptions"] as const,
  lists: () => [...adminTenantSubscriptionKeys.all, "list"] as const,
  list: (filters?: AdminTenantSubscriptionOverviewFilters) =>
    [...adminTenantSubscriptionKeys.lists(), filters] as const,
};

export const useAdminTenantSubscriptions = (
  enabled: boolean,
  filters?: AdminTenantSubscriptionOverviewFilters,
) =>
  useQuery({
    queryKey: adminTenantSubscriptionKeys.list(filters),
    queryFn: () =>
      adminTenantSubscriptionsService.getAllTenantSubscriptions(filters),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
    enabled,
  });
